import type { FormResponseOverviewReq } from '@components/DriverManagement/DriverForms/api/schema'
import { useApi } from '@gravitate-js/the-armory'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getAPIURL } from '@utils/api'

export const useFormAPI = () => {
  const api = useApi({ baseURLOverride: getAPIURL() })
  const queryClient = useQueryClient()

  const useFormsMetadata = () => {
    const payload = {}
    return useQuery({
      queryKey: ['formsMetadata', payload],
      queryFn: () => api.post('forms/metadata', payload),
    })
  }

  const useFormsOverview = () => {
    const payload = {}
    return useQuery({
      queryKey: ['formsOverview', payload],
      queryFn: () => api.post('forms/overview', payload),
    })
  }

  const useFormsUpsert = useMutation({
    mutationKey: ['formsUpsert'],
    mutationFn: (payload) => api.post('forms/upsert', payload),

    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['terminalDwellOverview'],
      })
    },
  })

  const useFormResponseOverview = (payload: FormResponseOverviewReq) => {
    return useQuery({
      queryKey: ['formsResponseOverview', payload],
      queryFn: () => api.post('forms/response/overview', payload),
    })
  }

  return {
    useFormsOverview,
    useFormsUpsert,
    useFormsMetadata,
    useFormResponseOverview,
  }
}
